import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import AdtfDeviceOverviewContextProvider from "./context/AdtfDeviceOverviewContext";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {ADTF_SIMPLE_ROUTE} from "../../util/RouteConstants";
import {ADTF_SIMPLE} from "../../util/Constants";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class AdtfSimplePage extends Component {
    render() {
        return (
            <Column>
                <AdtfDeviceOverviewContextProvider data={{assetSubtype: ADTF_SIMPLE}}>
                    <TabLayout routes={ADTF_SIMPLE_ROUTE} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={ADTF_SIMPLE_ROUTE}/>
                </AdtfDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default AdtfSimplePage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtfdevice/AdtfSimplePage.js